import React, { useEffect, useState } from "react";

import {
  AnchorLink,
  Button,
  Layout,
  Modal,
  Padding,
  Text,
} from "@kidslivesafe/sc-react";
import { useUnpauseSubscription } from "../../../hooks/pauseHook";
import { useAppSelector } from "../../../hooks/hooks";
import { selectAccountSubscriptionStatus } from "../../../features/authentication/authenticationSlice";

interface UnpauseCTAProps {
  type: "link";
}

const UnpauseCTA: React.FC<UnpauseCTAProps> = ({ type }) => {
  const [displayModal, setDisplayModal] = useState<boolean>(false);

  const handleUnpause = useUnpauseSubscription();
  const accountSubscriptionStatus = useAppSelector(
    selectAccountSubscriptionStatus,
  );

  useEffect(() => {
    if (accountSubscriptionStatus !== "PAUSED") {
      setTimeout(() => {
        setDisplayModal(false);
      }, 3000);
    }
  }, [accountSubscriptionStatus]);

  return (
    <>
      {accountSubscriptionStatus === "PAUSED" ? (
        <>
          {type === "link" && (
            <>
              {" - "}
              <AnchorLink
                color="primary"
                role="button"
                size="base"
                hoverUnderline
                inline
                handleClick={() => {
                  handleUnpause();
                  setDisplayModal(true);
                }}
              >
                Cancel Pause
              </AnchorLink>
            </>
          )}
        </>
      ) : null}
      <Modal
        open={displayModal}
        setOpen={() => {
          setDisplayModal(false);
        }}
        size="fit-content"
        outSideClose
        xClose
      >
        <Padding top="lg" bottom="lg" left="md" right="md">
          <Layout
            type="flex"
            flexProps={{
              direction: "column",
              gap: "lg",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Text textAlign="center" tag="h2" fontWeight="semibold">
              You've Successfully Unpaused Your Subscription{" "}
            </Text>

            <Button
              color="primary"
              buttonText="Continue"
              handleClick={() => {
                setDisplayModal(false);
              }}
            />
          </Layout>
        </Padding>
      </Modal>
    </>
  );
};

export default UnpauseCTA;
